var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dataIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(263 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h54v54H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dataIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 331",
    fill: "none",
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-263 -46)",
    clipPath: "url(#dataIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "DataIcon",
    transform: "translate(263 46)",
    clipPath: "url(#dataIcon_svg__b)",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 344",
    d: "M47.25 44.877h-2.373V20.988h-7.2v23.889h-2.371v-14.4h-7.119v14.4h-2.374V25.734h-7.119v19.143h-2.373V32.853h-7.2v12.024H6.75v2.373h40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 345",
    d: "M47.25 16.242V6.75h-9.572v2.373h5.52L31.746 20.497l-9.492-9.492L7.098 26.082l1.677 1.678 13.479-13.4 9.492 9.49 13.131-13.048v5.441z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/dataIcon.575634b3017c53cd.svg";
export { ForwardRef as ReactComponent };